import React from 'react';
import { SCORE_OPTIONS, SCORE_COLORS } from '../types';
import { ScorecardLayoutProps } from './types';

/**
 * Segmented layout — all five score options visible side-by-side. The
 * active option is outlined with the colour matched to its score.
 */
const ScorecardSegmentedLayout: React.FC<ScorecardLayoutProps> = ({
  currentScore,
  onSelect,
  readOnly,
}) => {
  return (
    <div className="h-full flex items-center justify-center bg-surface px-2">
      <div className="flex items-center gap-1.5">
        {SCORE_OPTIONS.map(option => {
          const isActive = currentScore === option.value;
          const colors = SCORE_COLORS[option.value];
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => !readOnly && onSelect(option.value)}
              disabled={readOnly}
              aria-pressed={isActive}
              className={[
                'w-9 h-8 rounded-md flex items-center justify-center text-xs font-semibold select-none transition-colors',
                isActive
                  ? `${colors.bg} ${colors.text} ${colors.border} border`
                  : 'border border-neutral-600 text-neutral-500 hover:text-neutral-300 hover:border-neutral-400',
                readOnly ? 'cursor-default' : 'cursor-pointer',
              ].join(' ')}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(ScorecardSegmentedLayout);
